"use strict";
/**
 * The four sign-up pages' shared frame and page copy, word for word from Anthony's
 * "How Fomo-Fi Works" (Oct 23, 2026; close_spec doc 3, "Every sign-up page" and
 * "The sign-up pages"). Both apps read these, so the step names and the counts
 * can't drift apart.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNUP_ANALYSIS_WAIT_COPY = exports.SIGNUP_FINISH_RETRY_COPY = exports.SIGNUP_FINISH_ERROR_COPY = exports.SIGNUP_ANALYSIS_AVERAGED_COPY = exports.SIGNUP_ANALYSIS_WORKING_COPY = exports.SIGNUP_ANALYSIS_FOUND_COPY = exports.SIGNUP_ANALYSIS_SPENDING_COPY = exports.SIGNUP_ANALYSIS_BILLS_COPY = exports.SIGNUP_ANALYSIS_PAYCHECKS_COPY = exports.SIGNUP_ANALYSIS_PROGRESS_LABEL_COPY = exports.SIGNUP_ANALYSIS_WAITING_BUTTON_COPY = exports.SIGNUP_ANALYSIS_DONE_HEADING_COPY = exports.SIGNUP_ANALYSIS_SPENDING_DONE_COPY = exports.SIGNUP_ANALYSIS_SPENDING_WORKING_COPY = exports.SIGNUP_ANALYSIS_BILLS_FOUND_COPY = exports.SIGNUP_ANALYSIS_PAYCHECKS_FOUND_COPY = exports.SIGNUP_ANALYSIS_BUTTON_COPY = exports.SIGNUP_ANALYSIS_IMPORTING_COPY = exports.SIGNUP_ANALYSIS_SUBLINE_COPY = exports.SIGNUP_ANALYSIS_HEADING_COPY = exports.BANK_NOT_FOUND_COPY = exports.SIGNUP_CONNECT_BANK_SMALL_PRINT_COPY = exports.SIGNUP_CONNECT_BANK_BUTTON_COPY = exports.SIGNUP_CONNECT_BANK_SUBLINE_COPY = exports.SIGNUP_CONNECT_BANK_HEADING_COPY = exports.SIGNUP_LOG_IN_LINK_COPY = exports.SIGNUP_LOG_IN_PROMPT_COPY = exports.SIGNUP_PASSWORDS_OK_COPY = exports.SIGNUP_CREATE_ACCOUNT_BUTTON_COPY = exports.SIGNUP_CREATE_ACCOUNT_SUBLINE_COPY = exports.SIGNUP_CREATE_ACCOUNT_HEADING_COPY = exports.SIGNUP_STEP_LABELS_COPY = exports.SIGNUP_STEP_BAR_LABEL_COPY = void 0;
exports.signupStepCopy = signupStepCopy;
exports.signupAnalysisChecklist = signupAnalysisChecklist;
exports.signupAnalysisHeadingCopy = signupAnalysisHeadingCopy;
/** The step bar's accessible name (Anthony's Sign-up boards: `<ol aria-label="Sign-up
 *  steps">`, §2). */
exports.SIGNUP_STEP_BAR_LABEL_COPY = "Sign-up steps";
/** The step bar's four names, in order. */
exports.SIGNUP_STEP_LABELS_COPY = [
    "Account",
    "Payment",
    "Bank",
    "Analysis",
];
/** The header's count, e.g. "Step 2 of 4". */
function signupStepCopy(step) {
    return `Step ${step} of ${exports.SIGNUP_STEP_LABELS_COPY.length}`;
}
/** 1 · Create account. */
exports.SIGNUP_CREATE_ACCOUNT_HEADING_COPY = "Create your account";
exports.SIGNUP_CREATE_ACCOUNT_SUBLINE_COPY = "Know what you can safely spend before payday hits.";
exports.SIGNUP_CREATE_ACCOUNT_BUTTON_COPY = "Create account";
exports.SIGNUP_PASSWORDS_OK_COPY = "Strong password · passwords match";
/** Under the main button (Anthony's Sign-up board "1 · Create account", §2): "Already have
 *  an account? Log in", the link going to sign-in. */
exports.SIGNUP_LOG_IN_PROMPT_COPY = "Already have an account?";
exports.SIGNUP_LOG_IN_LINK_COPY = "Log in";
/** 3 · Connect bank. */
exports.SIGNUP_CONNECT_BANK_HEADING_COPY = "Connect your bank";
exports.SIGNUP_CONNECT_BANK_SUBLINE_COPY = "Pick the checking account your paychecks land in.";
exports.SIGNUP_CONNECT_BANK_BUTTON_COPY = "Connect bank";
exports.SIGNUP_CONNECT_BANK_SMALL_PRINT_COPY = "Connected securely through Plaid. Can't find your bank? You won't be charged if you stop here.";
/** 3 · Connect bank, when a search finds nothing (D23). The amber panel's design is held
 *  (Part 4 #4); the sentence is fixed now so both apps use the same words. */
exports.BANK_NOT_FOUND_COPY = "We couldn't find that bank. Check the spelling or try another bank. If you stop here, your trial ends and you won't be charged.";
/** 4 · Analysis. */
exports.SIGNUP_ANALYSIS_HEADING_COPY = "Reviewing 12 months of your money";
exports.SIGNUP_ANALYSIS_SUBLINE_COPY = "Finding your paychecks, bills and everyday spending.";
exports.SIGNUP_ANALYSIS_IMPORTING_COPY = "Importing transactions";
exports.SIGNUP_ANALYSIS_BUTTON_COPY = "See my results in Plan";
/**
 * @deprecated The one-line status under the progress bar (doc 3's screenshot), replaced on
 * both apps by R2's checklist rows below (Anthony's Sign-up board "4 · Analysis"; Paul,
 * 2026-10-29, N8). Kept until mobile's mirror lands, then deleted.
 */
exports.SIGNUP_ANALYSIS_PAYCHECKS_FOUND_COPY = "Paychecks found";
/** @deprecated See SIGNUP_ANALYSIS_PAYCHECKS_FOUND_COPY. */
exports.SIGNUP_ANALYSIS_BILLS_FOUND_COPY = "Repeating bills found";
/** @deprecated See SIGNUP_ANALYSIS_PAYCHECKS_FOUND_COPY. */
exports.SIGNUP_ANALYSIS_SPENDING_WORKING_COPY = "Everyday spending, working…";
/** @deprecated Replaced by SIGNUP_ANALYSIS_AVERAGED_COPY ("Everyday spending · Averaged",
 *  N8). */
exports.SIGNUP_ANALYSIS_SPENDING_DONE_COPY = "Everyday spending found";
/**
 * R2 (Anthony's Sign-up board "4 · Analysis", Analysis.dc.html; addendum §1): the page
 * before and after the analysis completes.
 *
 * - The heading becomes SIGNUP_ANALYSIS_DONE_HEADING_COPY when done.
 * - The progress bar's accessible name is SIGNUP_ANALYSIS_PROGRESS_LABEL_COPY.
 * - Until done, the main button is disabled and reads SIGNUP_ANALYSIS_WAITING_BUTTON_COPY;
 *   when done it is "See my results in Plan" (SIGNUP_ANALYSIS_BUTTON_COPY).
 * - Three checklist rows, each a name and a status: Paychecks · Found; Repeating bills ·
 *   Found; Everyday spending · "Working…", then "Averaged" (N8: Paul, 2026-10-29).
 */
exports.SIGNUP_ANALYSIS_DONE_HEADING_COPY = "Your analysis is ready";
exports.SIGNUP_ANALYSIS_WAITING_BUTTON_COPY = "Results are on the way…";
exports.SIGNUP_ANALYSIS_PROGRESS_LABEL_COPY = "Import progress";
exports.SIGNUP_ANALYSIS_PAYCHECKS_COPY = "Paychecks";
exports.SIGNUP_ANALYSIS_BILLS_COPY = "Repeating bills";
exports.SIGNUP_ANALYSIS_SPENDING_COPY = "Everyday spending";
exports.SIGNUP_ANALYSIS_FOUND_COPY = "Found";
exports.SIGNUP_ANALYSIS_WORKING_COPY = "Working…";
exports.SIGNUP_ANALYSIS_AVERAGED_COPY = "Averaged";
/**
 * R2's three rows for a stage. While transactions are still arriving nothing is known
 * yet, so every row is "Working…". Once the analysis is being read, paychecks and bills
 * are found and everyday spending is still being averaged; when done it is "Averaged".
 */
function signupAnalysisChecklist(stage) {
    if (stage === "failed") {
        return [
            exports.SIGNUP_ANALYSIS_PAYCHECKS_COPY,
            exports.SIGNUP_ANALYSIS_BILLS_COPY,
            exports.SIGNUP_ANALYSIS_SPENDING_COPY,
        ].map((label) => ({ label, status: "", done: false }));
    }
    const found = stage !== "importing";
    const known = (label) => found
        ? { label, status: exports.SIGNUP_ANALYSIS_FOUND_COPY, done: true }
        : { label, status: exports.SIGNUP_ANALYSIS_WORKING_COPY, done: false };
    return [
        known(exports.SIGNUP_ANALYSIS_PAYCHECKS_COPY),
        known(exports.SIGNUP_ANALYSIS_BILLS_COPY),
        stage === "done"
            ? {
                label: exports.SIGNUP_ANALYSIS_SPENDING_COPY,
                status: exports.SIGNUP_ANALYSIS_AVERAGED_COPY,
                done: true,
            }
            : {
                label: exports.SIGNUP_ANALYSIS_SPENDING_COPY,
                status: exports.SIGNUP_ANALYSIS_WORKING_COPY,
                done: false,
            },
    ];
}
/** R2: the Analysis heading for a stage. */
function signupAnalysisHeadingCopy(stage) {
    return stage === "done"
        ? exports.SIGNUP_ANALYSIS_DONE_HEADING_COPY
        : exports.SIGNUP_ANALYSIS_HEADING_COPY;
}
/** 4 · Analysis, when finishing setup fails, and the way to try again (web's inline
 *  strings, moved here for both apps; rule 17, 2026-10-28). */
exports.SIGNUP_FINISH_ERROR_COPY = "We couldn't finish setting up. Check your connection and try again.";
exports.SIGNUP_FINISH_RETRY_COPY = "Try again";
/** Why "See my results in Plan" is off, for a screen reader (D25; the disabled look isn't
 *  designed, Part 4 #3).
 *  @deprecated R2 designs it: the disabled button itself reads "Results are on the way…"
 *  (SIGNUP_ANALYSIS_WAITING_BUTTON_COPY). Web no longer uses this; delete with mobile's
 *  mirror. */
exports.SIGNUP_ANALYSIS_WAIT_COPY = "Available when the analysis completes.";
//# sourceMappingURL=signupShellCopy.js.map